import { ClientError, ResponseFailureInterceptor } from '../types';

export const getErrorMessage = (error: ClientError | null) => {
  if (error?.response) {
    return error.response.data.detail ?? error.response.data.errorMessage ?? 'Unknown error';
  }

  return 'Unknown error';
};

const handleError = (): ResponseFailureInterceptor => (error) => {
  if (error.response) {
    error.message = getErrorMessage(error);
  }

  return Promise.reject(error);
};

export default handleError;
